import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import moment from "moment";
import { useGlobalContext } from "../Config";

const RenovarAsignacionDialog = ({ visible, onHide, idCotizacion, idCliente, desde, hasta, motivosOptions }) => {
    const { baseUrl } = useGlobalContext();
    const [hastaRenovacion, setHastaRenovacion] = useState(null);
    const [observacionRenovacion, setObservacionRenovacion] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (hasta && !hastaRenovacion) {
            const primerDisponible = moment(hasta, "YYYY-MM-DD", true).add(1, "day").startOf("day").toDate();
            setHastaRenovacion(primerDisponible);
        }
    }, [hasta, hastaRenovacion]);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            const idCreador = sessionStorage.getItem("usuario_id");
            if (!idCreador) throw new Error("Usuario no identificado. Inicia sesión para continuar.");
            const hastaRenovacionFormateada = moment(hastaRenovacion).format("YYYY-MM-DD");
            const resp = await fetch(`${baseUrl}renovar?idCotizacion=${idCotizacion}&idCreador=${idCreador}&fechaHastaRenovacion=${hastaRenovacionFormateada}&observacion=${observacionRenovacion}`, { method: "POST", headers: { "Content-Type": "application/json" } });
            const result = await resp.json();
            if (result.respuesta) {
                alert("La asignación ha sido renovada. Se ha creado una nueva cotización basada en la asignación actual.");
                setLoading(false);
                const newIdCotizacion = result.idCotizacion;
                const appBaseUrl = window.location.href.split("/#/")[0];
                const urlAVolver = `/revisarCotizacion?idCliente=${idCliente}&idCotizacion=${newIdCotizacion}&desde=${desde}&hasta=${hasta}`;
                window.location.href = `${appBaseUrl}/#${urlAVolver}`;
                window.location.reload();
            } else {
                setLoading(false);
                alert(`Error: ${result.mensaje}`);
            }
        } catch (error) {
            setLoading(false);
            alert(`Error: ${error.message}`);
        }
    };

    return (
        <Dialog 
            header="Renovación de Asignación" 
            visible={visible} 
            className="p-fluid product-dialog" 
            modal 
            onHide={onHide} 
            footer={
                <div>
                    <Button label="Cancelar" icon="pi pi-times" className="p-button p-button-rounded p-button-outlined" onClick={onHide} />
                    <Button label="Confirmar" icon={loading ? "pi pi-spin pi-spinner" : "pi pi-check"} className="p-button-success p-button-rounded p-button" raised onClick={handleConfirm} disabled={loading} />
                </div>
            }
        >
            <p className="text-sm text-color-secondary mb-3">
                La renovación tendrá vigencia a partir del <strong>día siguiente</strong> al término del contrato
                (<strong> {moment(hasta, "YYYY-MM-DD", true).isValid() ? moment(hasta, "YYYY-MM-DD", true).format("DD/MM/YYYY") : hasta}</strong>) 
                y se mantendrá hasta la fecha que usted determine.
            </p>
            <span className="p-float-label mt-2 mb-3">
                <Calendar id="fecha-hasta-renovacion" value={hastaRenovacion} onChange={(e) => setHastaRenovacion(e.value)} dateFormat="dd/mm/yy" placeholder="Seleccione una fecha..." className="w-full" minDate={moment(hasta, "YYYY-MM-DD", true).add(1, "day").toDate()} required />
                <label htmlFor="fecha-hasta-renovacion">Fecha hasta la cual se renovará *</label>
            </span>
            <span className="p-float-label mt-2 mb-3">
                <Dropdown id="observacion" value={observacionRenovacion} options={motivosOptions} onChange={(e) => setObservacionRenovacion(e.value)} optionLabel="label" placeholder="Seleccione un motivo de renovación..." className="w-full" required />
                <label htmlFor="observacion">Motivo de la renovación:</label>
            </span>
        </Dialog>
    );
};

export default RenovarAsignacionDialog;